/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AppointmentsidrescheduleAppointment from './AppointmentsidrescheduleAppointment';

/**
 * The IdRescheduleBody model module.
 * @module model/IdRescheduleBody
 * @version v0.3
 */
export default class IdRescheduleBody {
  /**
   * Constructs a new <code>IdRescheduleBody</code>.
   * @alias module:model/IdRescheduleBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IdRescheduleBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IdRescheduleBody} obj Optional instance to populate.
   * @return {module:model/IdRescheduleBody} The populated <code>IdRescheduleBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IdRescheduleBody();
      if (data.hasOwnProperty('appointment'))
        obj.appointment = AppointmentsidrescheduleAppointment.constructFromObject(data['appointment']);
    }
    return obj;
  }
}

/**
 * @member {module:model/AppointmentsidrescheduleAppointment} appointment
 */
IdRescheduleBody.prototype.appointment = undefined;

